import React from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import "./diwali.css";

// Ported from modak_main's shared header (src/pages/dddUI/user.jsx): real
// Extramile Play logo + Back button, hidden/redirected to the mobile app's
// native back action when opened inside the mobile app wrapper.
export default function DiwaliHeader() {
  const location = useLocation();
  const { user } = useSelector((state) => state.diwali);

  const fromMobileAppInUrl =
    String(new URLSearchParams(location.search).get("fromMobileApp") || "").toLowerCase() ===
    "true";
  const fromMobileAppInUser = String(user?.fromMobileApp || "").toLowerCase() === "true";
  const isFromMobileApp = fromMobileAppInUrl || fromMobileAppInUser;

  const logoUrl = process.env.REACT_APP_EM_LOGO;
  const backUrl = user?.gameId
    ? `${process.env.REACT_APP_BASE_URL}/game-detail/${user.gameId}`
    : process.env.REACT_APP_BASE_URL;

  const handleLogoClick = (e) => {
    if (!isFromMobileApp) return;
    e.preventDefault();
    window.GameStatus?.postMessage?.("navigate_back");
  };

  return (
    <div className="dw-header">
      <a href={process.env.REACT_APP_BASE_URL} onClick={handleLogoClick}>
        <img src={logoUrl} className="dw-header-logo-img" alt="Extramile Play" />
      </a>
      {!isFromMobileApp && (
        <a href={backUrl}>
          <button type="button" className="dw-header-back">
            Back
          </button>
        </a>
      )}
    </div>
  );
}
